/*
 * Copyright (c) 2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import NotificationsDialog from "./NotificationsDialog.jsx";
import {useNotificationStore} from "../../stores/NotificationStore.js";
import DisplayIcon from "../Icons/DisplayIcon.jsx";

function NotificationIcon() {
    const hasUnread = useNotificationStore((state) => state.notifications.some(item => !item.isRead));

    return (
        <>
            <button type="button"
                    onClick={() => {
                        NotificationsDialog()
                    }}
                    className="relative -m-2.5 p-2.5 text-gray-400 hover:text-gray-500">
                <span className="sr-only">View Notifications</span>
                <DisplayIcon iconName={"PiBell"} className="h-6 w-6"/>
                {/*{hasUnread && (*/}
                {/*    <span*/}
                {/*        className="absolute top-1.5 right-1.5 block h-2 w-2 rounded-full bg-red-500 ring-2 ring-white"/>*/}
                {/*)}*/}
            </button>
        </>
    );
}

export default NotificationIcon;